module.exports = __webpack_public_path__ + "static/media/JakeOptimized.39de281e.png";